import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      Toast.fire({ icon: 'warning', title: 'Missing credentials' });
      return;
    }
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      Toast.fire({ icon: 'success', title: 'Admin Verified' });
      navigate('/home');
    } catch (error) {
      Toast.fire({ icon: 'error', title: 'Invalid Password' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.glassContainer}>
        
        {/* LEFT PANEL: BRANDING */}
        <div style={styles.leftPanel}>
          <div style={styles.brandContent}>
            <div style={styles.iconBox}>
              <span style={{fontSize: '40px'}}>⛽</span>
            </div>
            <h1 style={styles.mainTitle}>PETROLEUM MGMT</h1>
            <div style={styles.line}></div>
            <p style={styles.version}>Enterprise Dashboard v2.0</p>
          </div>
        </div>

        {/* RIGHT PANEL: FORM */}
        <div style={styles.rightPanel}>
          <form style={styles.form} onSubmit={handleLogin}>
            <h2 style={styles.loginTitle}>Admin Login</h2>
            <p style={styles.instruction}>Access restricted to pump authorities</p>

            <div style={styles.inputGroup}>
              <label style={styles.label}>EMAIL ADDRESS</label>
              <input 
                type="email" 
                style={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>PASSWORD</label>
              <input 
                type="password" 
                style={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button type="submit" style={styles.btn} disabled={loading}>
              {loading ? 'Processing...' : 'LOGIN TO SYSTEM'}
            </button>

            <p style={styles.footerNote}>
              Strict Security: <b>Authorized Personnel Only</b>
            </p>
          </form>
        </div>

      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0f172a',
    backgroundImage: `radial-gradient(circle at 20% 30%, #2d0000 0%, #0f172a 100%)`, // Deep red glow
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  glassContainer: {
    display: 'flex',
    width: '900px',
    height: '550px',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(10px)',
    borderRadius: '24px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
  },
  leftPanel: {
    flex: 1,
    background: 'linear-gradient(135deg, #FF1A1A 0%, #8B0000 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  brandContent: {
    textAlign: 'center',
    color: '#fff',
  },
  iconBox: {
    width: '80px',
    height: '80px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  mainTitle: {
    fontSize: '28px',
    fontWeight: '900',
    letterSpacing: '2px',
    margin: 0,
  },
  subTitle: {
    fontSize: '12px',
    letterSpacing: '5px',
    marginTop: '5px',
    opacity: 0.8,
  },
  line: {
    width: '40px',
    height: '4px',
    backgroundColor: '#fff',
    margin: '20px auto',
    borderRadius: '2px',
  },
  version: {
    fontSize: '10px',
    opacity: 0.5,
    textTransform: 'uppercase',
  },
  rightPanel: {
    flex: 1.2,
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  form: {
    width: '100%',
    maxWidth: '320px',
  },
  loginTitle: {
    fontSize: '24px',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  instruction: {
    fontSize: '13px',
    color: '#64748b',
    marginBottom: '30px',
  },
  inputGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#94a3b8',
    marginBottom: '8px',
    letterSpacing: '0.5px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'all 0.3s ease',
  },
  btn: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#FF1A1A',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxShadow: '0 10px 15px -3px rgba(255, 26, 26, 0.3)',
    marginTop: '10px',
    transition: 'transform 0.2s ease',
  },
  footerNote: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#cbd5e1',
    marginTop: '30px',
  }
};